import { forwardRef, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import { DialogContent, PedidoFiltroContainer, PedidoVentaContainer, PedidoTotalContainer, styles } from './PedidosComponents';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { AiOutlineClose } from 'react-icons/ai';
import Slide from '@mui/material/Slide';
import PieDeVenta from './venta/PieDeVenta';
import Cabecera from './venta/Cabecera';
import Totales from './venta/Totales';
import Card from '../../components/Card/Card';
import { PedidosContext } from '../../context/PedidosContext';
import { AdminContext } from '../../context/AdminContext';
import { MEDIO_DE_PAGO, PEDIDO_ESTADO, SNACKBAR_SEVERITY } from '../../constants';
import { useState } from 'react';
import CircleLoader from 'react-spinners/CircleLoader'
import Axios from '../../extras/Axios';
import RastreoDialog from '../../components/dialog_login/RastreoDialog'; // Lo crearemos luego

const useStyles = makeStyles(styles);
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});


function ModalPedido({ modal, toggleModal }) {

  const classes = useStyles();
  const { handleClickSnackbar } = useContext(AdminContext);
  const { ventaActual, crearVenta, clearTab, listado, validateProductsForSale, marcarProductosNoDisponibles, totalFinal } = useContext(PedidosContext);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showRastreo, setShowRastreo] = useState(false);

  function checkValidity() {
    let isValid = true;

    const checkUserSaldo = totalFinal > selectedUser?.saldoNotaCredito;
    const checkFieldSaldo = totalFinal > ventaActual.pagoNotaCredito;

    if(selectedUser?.identificador !== "9999" && (selectedUser?.preferenciaPago !== "CREDITO" && selectedUser?.preferenciaPago !== "EFECTIVO")){
      handleClickSnackbar('El usuario no seleccionó una preferencia de pago', SNACKBAR_SEVERITY.info);
        isValid = false;
    }

    if (totalFinal > 0 && checkUserSaldo && checkFieldSaldo) {
      if ((ventaActual.medioDePago === MEDIO_DE_PAGO.CREDITO_Y_EFECTIVO || ventaActual.medioDePago === MEDIO_DE_PAGO.EFECTIVO) && (ventaActual.pagoEfectivo <= 0)) {
        handleClickSnackbar('Debe completar el campo "Monto en efectivo"', SNACKBAR_SEVERITY.info);
        isValid = false;
      }
      if ((ventaActual.medioDePago === MEDIO_DE_PAGO.CREDITO_Y_EFECTIVO || ventaActual.medioDePago === MEDIO_DE_PAGO.CUENTA_CORRIENTE) && (ventaActual.pagoCredito <= 0)) {
        handleClickSnackbar('Debe completar el campo "Monto en crédito"', SNACKBAR_SEVERITY.info);
        isValid = false;
      }
      if (ventaActual.compradorId === "") {
        handleClickSnackbar('Antes de finalizar una venta elija un usuario', SNACKBAR_SEVERITY.info);
        isValid = false;
      }
    }

    if (ventaActual.estado === PEDIDO_ESTADO.ENTREGADO) {
      if (ventaActual.medioDePago === "" || ventaActual.medioDePago === MEDIO_DE_PAGO.NINGUNO) {
        handleClickSnackbar('Antes de finalizar una venta elija un medio de pago', SNACKBAR_SEVERITY.info);
        isValid = false;
      }
    }

    if (!ventaActual.compradorId || ventaActual.compradorId === "") {
      handleClickSnackbar('Seleccione un cliente para el pedido', SNACKBAR_SEVERITY.info);
      isValid = false;
    }
    if (listado.length === 0) {
      handleClickSnackbar('No hay productos seleccionados', SNACKBAR_SEVERITY.info);
      isValid = false;
    }

    return isValid;
  }

  const handleClose = async () => {
    setLoading(true);
    if (!checkValidity()) {
      setLoading(false);
      return;
    }

    // Si corresponde, mostrar modal de rastreo
    if (ventaActual.tiendaNubeId && ventaActual.estado === PEDIDO_ESTADO.ENTREGADO) {
      setShowRastreo(true);
      setLoading(false);
      return;
    }

    const productValidationResults = await validateProductsForSale();
    marcarProductosNoDisponibles(productValidationResults.map(p => p._id));
    if (productValidationResults.length > 0) {
      let message = 'Los siguientes elementos seran removidos de la lista por encontrarse vendidos:\n';
      productValidationResults.forEach(prod => {
        message += `${prod.descripcion}\n`
      })
      setLoading(false);
      alert(message);
      return;
    }

    const { message, reservados, notaCredito, saldoInsuficiente } = await crearVenta();
    handleClickSnackbar(message, SNACKBAR_SEVERITY.info);
    if (notaCredito && notaCredito !== '') {
      alert(notaCredito);
    }
    if (saldoInsuficiente && saldoInsuficiente !== '') {
      alert(saldoInsuficiente);
    }
    if (reservados && reservados.length > 0) {
      alert(reservados.join(''));
    }
    setSelectedUser(null);
    setLoading(false);
    toggleModal();
  };

  // Cuando se confirma el modal de rastreo
  const handleRastreoConfirm = async (codigo, link) => {
    setShowRastreo(false);
    setLoading(true);
    const productValidationResults = await validateProductsForSale();
    marcarProductosNoDisponibles(productValidationResults.map(p => p._id));
    if (productValidationResults.length > 0) {
      let message = 'Los siguientes elementos seran removidos de la lista por encontrarse vendidos:\n';
      productValidationResults.forEach(prod => {
        message += `${prod.descripcion}\n`
      })
      setLoading(false);
      alert(message);
      return;
    }
    // Pasar los datos de rastreo a crearVenta
    const { message, reservados, notaCredito, saldoInsuficiente } = await crearVenta({ codigoRastreo: codigo, linkRastreo: link });
    handleClickSnackbar(message, SNACKBAR_SEVERITY.info);
    if (notaCredito && notaCredito !== '') {
      alert(notaCredito);
    }
    if (saldoInsuficiente && saldoInsuficiente !== '') {
      alert(saldoInsuficiente);
    }
    if (reservados && reservados.length > 0) {
      alert(reservados.join(''));
    }
    setSelectedUser(null);
    setLoading(false);
    toggleModal();
  };

  const handleRastreoCancel = () => {
    setShowRastreo(false);
  };

  const getUserById = async (identificador)=>{
    if (!identificador) return
    try {
      const result = await Axios.get(`/users/${identificador}`);
      const user = await result.data;
      setSelectedUser(user)
    } catch (error) {
      setTimeout(()=> getUserById(identificador), 3000)
    }
  }

  useEffect(() => {
    getUserById(ventaActual.compradorId)
  }, [ventaActual.compradorId])
  
  return (
    <div>
      <Dialog fullScreen onClose={toggleModal} aria-labelledby='customized-dialog-title' open={modal} TransitionComponent={Transition}>
        <CircleLoader loading={loading} cssOverride={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
        <div style={{ opacity: loading ? 0 : 100 }}>
          <AppBar className={classes.appBar} style={{ opacity: loading ? 0 : 100 }}>
            <Toolbar>
              <IconButton
                edge='start'
                color='inherit'
                onClick={() => {
                  clearTab();
                  setSelectedUser(null);
                  toggleModal();
                }}
                aria-label='close'
                size="large">
                <AiOutlineClose />
              </IconButton>

              <Typography variant='h6' className={classes.title}>
                Pedido {ventaActual.numero !== '' ? '#' + ventaActual.numero + '\n' : 'nuevo -\n'}
                {
                  selectedUser && selectedUser.identificador !== "9999" ? (
                    `${selectedUser?.dni ? "DNI: " + selectedUser?.dni : ''} Opción: ${selectedUser.preferenciaPago}` +
                    (selectedUser.saldoCredito > 0 && selectedUser.preferenciaPago === 'CREDITO'
                      ? ` - Saldo Crédito: $${selectedUser.saldoCredito?.toFixed(2)}`
                      : '') +
                    (selectedUser.saldoEfectivo > 0 && selectedUser.preferenciaPago === 'EFECTIVO'
                      ? ` - Saldo Efectivo: $${selectedUser.saldoEfectivo?.toFixed(2)}`
                      : '') +
                    (selectedUser.saldoNotaCredito ? ` - Saldo Nota crédito: $${selectedUser.saldoNotaCredito.toFixed(2)}` : '')
                  ) : ''
                }
              </Typography>
              <Button autoFocus color='inherit' onClick={async () => await handleClose()}>
                Finalizar
              </Button>
            </Toolbar>
          </AppBar>
          <PedidoFiltroContainer>
            <PedidoVentaContainer>
              <Cabecera />
              <PieDeVenta />
            </PedidoVentaContainer>
            <PedidoTotalContainer>
              <Card>
                <Totales selectedUser={selectedUser} notadCredito={selectedUser?.saldoNotaCredito} />
              </Card>
            </PedidoTotalContainer>
          </PedidoFiltroContainer>
          <DialogContent dividers>
          </DialogContent>
        </div>
        {/* Modal de rastreo */}
        <RastreoDialog open={showRastreo} onConfirm={handleRastreoConfirm} onCancel={handleRastreoCancel} />
      </Dialog>
    </div>
  );
}

ModalPedido.propTypes = {
  modal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
};

export default ModalPedido;
